import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeletionDialogComponent } from 'src/app/layout/deletion-dialog/deletion-dialog.component';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';

import { SpinnerService } from 'src/app/layout/spinner.service';
import { GsaSettingsDialogComponent } from './gsa-settings-dialog/gsa-settings-dialog.component';
import { GSA } from './gsa-settings.model';
import { GsaService } from './gsa-settings.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatChip } from '@angular/material/chips';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-gsa-settings',
    templateUrl: './gsa-settings.component.html',
    styleUrls: ['./gsa-settings.component.scss'],
    imports: [MatDivider, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatChip, NgClass, MatIconButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class GsaSettingsComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  constructor(
    private spinnerService: SpinnerService,
    private gsaSettingsService: GsaService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog
  ) {}

  searchForm: UntypedFormGroup;

  displayedColumns: string[] = ['id', 'gsaName', 'status', 'actions'];
  tabledata: GSA[] = [];
  dataSource = new MatTableDataSource();
  dialogConfig = new MatDialogConfig();

  ngOnInit(): void {
    this.fetchData();
    this.searchForm = new UntypedFormGroup({
      filter: new UntypedFormControl(''),
    });
  }

  fetchData(): void {
    this.spinnerService.startSpinner();
    this.gsaSettingsService.fetchGsas().subscribe(
      (data: GSA[]) => {
        this.tabledata = data;

        this.dataSource = new MatTableDataSource(this.tabledata);
        this.dataSource.paginator = this.paginator;
        this.spinnerService.stopSpinner();

      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      }
    );
  }

  deleteColumn(gsa: GSA, index: number): void {
    const dialogRef = this.dialog.open(
      DeletionDialogComponent,
      this.dialogConfig
    );

    dialogRef.afterClosed().subscribe((data) => {
      this.spinnerService.startSpinner();
      if (data) {
        this.gsaSettingsService.deleteGsa(gsa.id).subscribe(
          () => {
            this.fetchData();
            this.snackbarService.openSuccess();
          },
          (error: any) => {
            this.spinnerService.stopSpinner();
            this.snackbarService.openError(error.status);
          }
        );
      }
    });
  }

  openEdit(data: any, rowIndex?: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxHeight = '800px';
    dialogConfig.width = '800px';
    const dialogRef = this.dialog.open(
      GsaSettingsDialogComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((data: GSA) => {
      if (data) {
        this.submit(data);
      }else{
        this.fetchData();
      }
    });
  }
  submit(gsa: GSA): void {
    this.spinnerService.startSpinner();
    // wenn id vorhanden: update
    if (gsa.id) {
      this.gsaSettingsService.putGsa(gsa).subscribe(
        (data: GSA) => {
          for (let i = 0; i < this.tabledata.length; i++) {
            if (this.tabledata[i].id == data.id) {
              this.tabledata[i] = data;
              this.spinnerService.stopSpinner();
              this.snackbarService.openSuccess();
            }
          }

          this.refreshTable(this.tabledata);
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    } else {
      // wenn keine id vorhanden: create
      this.gsaSettingsService.postGsa(gsa).subscribe(
        (data: GSA) => {
          this.tabledata.push(data);
          this.refreshTable(this.tabledata);
          this.spinnerService.stopSpinner();
          this.snackbarService.openSuccess();
        },
        (error: any) => {
          this.spinnerService.stopSpinner();
          this.snackbarService.openError(error.status);
        }
      );
    }
  }

  openAdd(): void {
    const dialogRef = this.dialog.open(GsaSettingsDialogComponent, {
      width: '800px',
      maxHeight: '800px',
    });
    dialogRef.afterClosed().subscribe((data: GSA) => {
      if (data) {
        this.submit(data);
      }
    });
  }

  refreshTable(tabledata: GSA[]): void {
    this.dataSource = new MatTableDataSource(tabledata);
    this.dataSource.paginator = this.paginator;
  }

  // -- search --
  clearSearch(): void {
    this.searchForm.controls['filter'].setValue('');
    this.applyFilter();
  }

  applyFilter(): void {
    const filterValue = this.searchForm.value.filter;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
